module.exports = __webpack_public_path__ + "img/icon_reject_default.078e191a.svg";